module.exports = __webpack_public_path__ + "static/media/11.04eff3bd.jpg";